// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeleteInvoiceMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type DeleteInvoiceMutationResult = { __typename?: 'Mutation', deleteInvoice: boolean };

export const DeleteInvoiceGql = gql`
    mutation DeleteInvoice($id: Int!) {
  deleteInvoice(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInvoiceInjectable extends Apollo.Mutation<DeleteInvoiceMutationResult, DeleteInvoiceMutationVariables> {
    override document = DeleteInvoiceGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */